import React from 'react';
import { Helmet } from "react-helmet";

const HelmetEl = () => {
    const { 
        REACT_APP_USERNAME: userName,
        REACT_APP_DOMAIN: domain,
        REACT_APP_DESCRIPTION: description
    } = process.env;

    return (
        <Helmet
            defaultTitle={userName}
            titleTemplate={`${userName} - %s`}
        >
            <html lang="en" amp />
            <title itemProp="name" lang="en">Portfolio</title>
            <base target="_blank" href={domain} />
            <meta name="description" content={description} />
            <meta property="og:type" content="article" />
            <link rel="canonical" href={domain} />
        </Helmet>
    )
}
export { HelmetEl };
